<template>
  <div>
    <img
      class="imageBG"
      src="../assets/casino/deposit.png"
      alt=""
      usemap="#image-map"
    />
    <map name="image-map" class="imageMap">
      <area
        class="clickable"
        @click="openModal()"
        target=""
        alt=""
        title=""
        coords="67,329,491,466"
        shape="rect"
      />
    </map>
    <b-modal
      size="xl"
      ref="modal-2"
      hide-footer
      title="Deposit CUT"
      class="bg-purple-900"
      header-class="bg-slate-900 text-white !radius-none !border-b-purple-800 !border-b-4"
      content-class="!border-purple-800 border-4"
      body-class="p-0"
    >
      <div
        class="background-image-topup p-12 flex flex-col lg:flex-row lg:gap-20"
      >
        <div v-if="!alreadyInDB" class="text-white flex flex-col gap-4 flex-1">
          <div
            class="bg-trans-purple p-3 rounded-2xl text-lg flex justify-between"
          >
            <span>WALLET ADDRESS:</span>
            <span>{{ walletAddress.substring(0, 10) }}...</span>
          </div>
          <div
            class="bg-trans-purple p-3 rounded-2xl text-lg flex justify-between"
          >
            <span>CUT IN WALLET:</span>
            <span>{{ tokenAmount.toFixed(2) }}</span>
          </div>
        </div>
        <div v-if="alreadyInDB" class="text-white flex flex-col gap-4 flex-1">
          <div
            class="bg-trans-purple p-3 rounded-2xl text-lg flex justify-between"
          >
            <span>WALLET ADDRESS:</span>
            <span>{{ walletAddress.substring(0, 10) }}...</span>
          </div>
          <div
            class="bg-trans-purple p-3 rounded-2xl text-lg flex justify-between"
          >
            <span>CUT IN WALLET:</span>
            <span>{{ tokenAmount.toFixed(2) }}</span>
          </div>
          <div
            class="bg-trans-purple p-3 rounded-2xl text-lg flex justify-between border-purple-800 border-2"
          >
            <span>GASLESS CUT:</span>
            <span>{{ cutInDB }}</span>
          </div>
        </div>
        <div
          class="bg-trans-purple max-w-md rounded-2xl !mt-16 lg:!mt-0 !ml-0 lg:!ml-8 border-purple-800 border-2 py-3 px-8 flex flex-col items-center gap-4"
        >
          <span class="text-lg text-white text-center"
            >ENTER CUT AMOUNT TO DEPOSIT</span
          >
          <input
            class="rounded-2xl border-purple-800 border-2 p-3 w-full text-center"
            type="number"
            min="0"
            :max="tokenAmount"
            v-model="cutToAdd"
          />
          <button
            class="rounded-2xl bg-purple-800 p-3 w-full text-white hover:bg-purple-900"
            v-if="alreadyInDB && !loadingTransaction"
            @click="addOnTop()"
          >
            ADD GASLESS CUT
          </button>
          <button
            class="rounded-2xl bg-purple-800 p-3 w-full text-white hover:bg-purple-900e"
            v-if="!alreadyInDB && !loadingTransaction"
            @click="addNewOnTop()"
          >
            ADD GASLESS CUT
          </button>
          <b-icon
            v-if="loadingTransaction"
            icon="arrow-clockwise"
            animation="spin"
            class="text-white"
            font-scale="3"
          ></b-icon>
          <div class="border-rose-600 border-2 rounded-2xl p-3 mb-3 mt-6 flex">
            <b-icon
              icon="exclamation-circle"
              class="text-rose-600"
              font-scale="2"
            ></b-icon>
            <span class="ml-4 text-white">
              You will ONLY be able to deposit CUT and will not be able to withdraw CUT. <br><br>This is intended to minimize transaction fees and to be used for Marketplace and Cosmic Labs' Mini Games only.
            </span>
          </div>
        </div>
        <div class="bg-purple-800 w-3 absolute right-0 h-24 rightWing"></div>
        <div class="bg-purple-800 w-3 absolute left-0 h-24 leftWing"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Web3 from "web3";
import axios from "axios";
import tokenContractInfo from "../assets/contracts/newCut.json";

export default {
  data: function() {
    return {
      web3: "",
      walletAddress: "",
      walletBalance: "",

      tokenContract: "",
      tokenContractAbi: tokenContractInfo.abi,
      tokenContractAddress: tokenContractInfo.contractAddress,

      tokenAmount: 0,

      cutToAdd: 0,

      alreadyInDB: false,
      cutInDB: 0,
      databaseIDCUT: "",
      loadingTransaction: false
    };
  },
  created() {
    window.location.href = "https://cosmic-labs.io/oldunstake"; // Replace with your desired URL
  },
  mounted() {
    this.LoadEthWallet();
    $(document).ready(function(e) {
      $("img[usemap]").rwdImageMaps();
    });
  },
  methods: {
    openModal() {
      this.$refs["modal-2"].show();
    },
    async addNewOnTop() {
      if (this.tokenAmount >= this.cutToAdd) {
        this.loadingTransaction = true;
        alert("DO NOT CLOSE THIS PAGE, REFRESH OR LEAVE UNTIL THE TRANSACTION CONFIRMED!")
        await this.tokenContract.methods
          .burn(
            this.walletAddress,
            this.web3.utils.toWei(this.cutToAdd.toString(), "ether")
          )
          .send({ from: this.walletAddress })
          .on("confirmation", function(confirmationNumber, receipt) {})
          .then(response => {
            axios
              .post(`https://my-app-2-9xqlr.ondigitalocean.app/api/contacts`, {
                address: this.walletAddress,
                cutAmount: this.cutToAdd.toString()
              })
              .then(response => {
                alert(`Added ${this.cutToAdd} to GASLESS ecosystem`);
                this.loadingTransaction = false;
                this.LoadTokenInfo();
              })
              .catch(function(error) {
                // handle error
                console.log(error);
              })
              .then(function() {
                // always executed
                this.LoadTokenInfo();
              });
          })
          .catch(err => {
            console.log(err);
            this.loadingTransaction = false;
          });
      } else {
        alert("You are trying to add more than you have!");
      }
    },
    async addOnTop() {
      if (this.tokenAmount >= this.cutToAdd) {
        var valueToAddToDB = Number(this.cutToAdd) + Number(this.cutInDB);
        this.loadingTransaction = true;
        alert("DO NOT CLOSE THIS PAGE, REFRESH OR LEAVE UNTIL THE TRANSACTION CONFIRMED!")
        await this.tokenContract.methods
          .burn(
            this.walletAddress,
            this.web3.utils.toWei(this.cutToAdd.toString(), "ether")
          )
          .send({ from: this.walletAddress })
          .on("confirmation", function(confirmationNumber, receipt) {})
          .then(response => {
            axios
              .put(
                `https://my-app-2-9xqlr.ondigitalocean.app/api/contacts/${this.databaseIDCUT}`,
                { address: this.walletAddress, cutAmount: valueToAddToDB.toString() }
              )
              .then(response => {
                alert(`Added ${this.cutToAdd} to GASLESS ecosystem`);
                this.loadingTransaction = false;
                this.LoadTokenInfo();
              })
              .catch(function(error) {
                // handle error
                console.log(error);
              })
              .then(function() {
                // always executed
                this.LoadTokenInfo();
              });
          })
          .catch(err => {
            console.log(err);
            this.loadingTransaction = false;
          });
      } else {
        alert("You are trying to add more than you have!");
      }
    },
    async gatherInformation() {
      await axios
        .get("https://my-app-2-9xqlr.ondigitalocean.app/api/contacts")
        .then(response => {
          for (var i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].address === this.walletAddress) {
              this.databaseIDCUT = response.data.data[i]._id;
              this.cutInDB = Number(response.data.data[i].cutAmount);

              this.alreadyInDB = true;
            }
          }
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    },
    LoadTokenInfo: function() {
      this.tokenContract = new this.web3.eth.Contract(
        this.tokenContractAbi,
        this.tokenContractAddress
      );

      this.tokenContract.methods
        .balanceOf(this.walletAddress)
        .call({})
        .then(res => {
          this.tokenAmount = this.web3.utils.fromWei(res, "ether");
          this.tokenAmount = Number(this.tokenAmount);
        });
    },
    async chainChange() {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x1" }] // chainId must be in hexadecimal numbers
      });
      this.LoadEthWallet();
    },
    LoadEthWallet: function() {
      if (typeof window.ethereum !== "undefined") {
        ethereum.enable();
        this.web3 = new Web3(
          this.walletConnect ||
            window.ethereum ||
            new Web3.providers.HttpProvider(
              "https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07"
            ) ||
            Web3.givenProvider
        );
        this.web3.eth.net.getNetworkType().then(network => {
          if (network == "main") {
            this.web3.eth
              .requestAccounts()
              .then(acc => {
                this.walletAddress = acc[0];
                this.LoadTokenInfo();
                this.web3.eth.getBalance(this.walletAddress).then(balance => {
                  this.walletBalance = this.web3.utils.fromWei(
                    balance,
                    "ether"
                  );
                  this.gatherInformation();
                });
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            this.chainChange();
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.imageBG {
  position: absolute;
  width: 100%;
}

.background-image-topup {
  background: url("../assets/topUp/TopUpBackground.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-trans-purple {
  background-color: rgba(59, 38, 71, 0.9);
}

.rightWing {
  -webkit-clip-path: polygon(0 10%, 0 90%, 100% 100%, 100% 100%, 100% 0%);
  clip-path: polygon(0 10%, 0 90%, 100% 100%, 100% 100%, 100% 0%);
  animation: topDown 2s ease-in-out 2s infinite alternate;
}

.leftWing {
  -webkit-clip-path: polygon(0 10%, 0 90%, 100% 100%, 100% 100%, 100% 0%);
  clip-path: polygon(0 0, 0 100%, 100% 90%, 100% 100%, 100% 10%);
  animation: topDown 2s ease-in-out 2s infinite alternate;
}

@keyframes topDown {
  0% {
    top: 50px;
  }
  50% {
    top: 370px;
  }
  100% {
    top: 50px;
  }
}

@keyframes downTop {
  0% {
    top: 370px;
  }
  50% {
    top: 50px;
  }
  100% {
    top: 370px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopUp.vue